import { useEffect, useState } from 'react';

export function useGoogleMapsScript() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const scriptId = 'google-maps-script';

    if (window.google?.maps) {
      setIsLoaded(true);
      return;
    }

    if (document.getElementById(scriptId)) {
      const existingScript = document.getElementById(scriptId);
      existingScript.addEventListener('load', () => setIsLoaded(true));
      existingScript.addEventListener('error', () =>
        setError('Erro ao carregar script do Google Maps.')
      );
      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&libraries=places&callback=noOperation`;
    script.async = true;
    script.defer = true;

    script.onload = () => setIsLoaded(true);
    script.onerror = () => setError('Erro ao carregar script do Google Maps.');

    document.body.appendChild(script);
  }, []);

  return { isLoaded, error };
}
